<app-modal [title]="effectiveTitle() | translate" maxWidth="520px" (close)="onClose()">
  <div class="modal-content">
    <p class="modal-message">
      {{ effectiveMessage() | translate }}
    </p>

    @if (effectiveSubtitle()) {
      <p class="modal-subtitle">
        {{ effectiveSubtitle() | translate }}
      </p>
    }
  </div>

  <app-button
    [label]="effectiveButtonLabel() | translate"
    (click)="onContinue()"
  />
</app-modal>
